<template>
  <!-- 快递选项 -->
  <RadioTable2
    v-model="val"
    radioLabel="#"
    :loading="loading"
    :height="230"
    :isError="isError"
    :radioKey="radioKey"
    :columns="columns"
    :tableData="options"
    @change="handleChange"
  >
    <template v-slot:freight_amount="{ row }">
      {{ row.shipping_pay_type == 2 ? '到付' : `￥${row.freight_amount}` }}
      <span v-if="row.freight_amount === 0" class="express-free">
        包邮
      </span>
    </template>
    <template slot="empty">
      {{ emptyText }}
    </template>
  </RadioTable2>
</template>

<script>
import RadioTable2 from '@@/components/radioTable/index2'

import { isLogin } from '@@/utils/is'
import { getPcbExpress } from '@@/api/pcb'

export default {
  props: {
    mountRef: {
      type: Function,
      default: () => () => {}
    },
    value: {
      type: [String, Number],
      default: ''
    },
    radioKey: {
      type: String,
      default: 'shipping_id'
    },
    params: {
      type: Object,
      default: () => ({})
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RadioTable2
  },
  data() {
    return {
      loading: false,
      val: this.value,
      options: [],
      columns: [
        { label: '快递名称', prop: 'shipping_name' },
        { label: '快递费', prop: 'freight_amount', slot: 'freight_amount' },
        { label: '预计送货时效', prop: 'shipping_time', minWidth: 130 }
      ]
    }
  },
  computed: {
    currentItem() {
      const { val, radioKey, options } = this
      return options.find(item => item[radioKey] === val) || {}
    },
    // 无数据文案
    emptyText() {
      if (!isLogin()) {
        return '请先登录并填写收货地址'
      }
      if (!this.params.province) {
        return '请先填写收货地址'
      }
      return '暂无快递'
    }
  },
  watch: {
    value(newVal) {
      this.val = !isNaN(Number(newVal)) ? Number(newVal) : newVal
    }
  },
  mounted() {
    this.mountRef({
      getList: () => this.getList()
    })
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
    },
    handleChange(item) {
      this.handleEmit()
      this.$emit('change', item)
    },
    // 获取快递列表
    async getList() {
      try {
        this.loading = true
        const res = await this.getPcbExpress()

        this.options = res
        // 当有选中快递 且 选中的快递不在选项中时，清空选中的快递
        if (this.val && !res.map(i => i.shipping_id).includes(this.val)) {
          this.val = ''
          this.handleChange()
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // 获取PCB快递列表
    async getPcbExpress() {
      return await getPcbExpress(this.params)
        .then(res => {
          if (!res) return []
          const { retCode, result } = res
          return retCode === 0 ? result : []
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.express-free {
  display: inline-block;
  width: 36px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: $--color-warning;
  text-align: center;
  border-radius: 2px;
  background-color: #FDF6EC;
}
</style>